// TODO: Rename the view query param string as part of https://jira.taboola.com/browse/LA-47351
export const REPORT_PRESET_PARAM_NAME = 'reportViewName';
export const REPORT_PARAM_TEMPLATE = `/:${REPORT_PRESET_PARAM_NAME}?`;
